<script lang="ts">
  import { Icon } from '$ui/primitives/Icon';

  let {
    src,
    name,
    size = 'md',
    online = false,
    showStatus = false,
    class: className = ''
  }: {
    src?: string | null;
    name?: string;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    online?: boolean;
    showStatus?: boolean;
    class?: string;
  } = $props();

  let hasError = $state(false);

  const initial = $derived(
    name && name.trim().length > 0 ? name.trim().charAt(0).toUpperCase() : null
  );
  const showImg = $derived(src && !hasError);
</script>

<span
  class="avatar {className}"
  data-size={size}
  data-online={online || undefined}
  data-show-status={showStatus || undefined}
  role={name ? 'img' : undefined}
  aria-label={name}
>
  {#if showImg}
    <img
      {src}
      alt=""
      loading="lazy"
      onerror={() => (hasError = true)}
    />
  {:else if initial}
    <span class="initial" aria-hidden="true">{initial}</span>
  {:else}
    <span class="fallback" aria-hidden="true">
      <Icon name="user" size={size === 'xl' ? 32 : size === 'lg' ? 20 : 14} />
    </span>
  {/if}
  {#if showStatus}
    <span class="status" aria-hidden="true"></span>
  {/if}
</span>

<style>
  .avatar {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    border-radius: 50%;
    overflow: hidden;
    background: var(--color-surface-sunken);
    color: var(--color-text-muted);
    border: var(--border-width) solid var(--color-border);
    font-family: var(--font-mono);
    font-weight: var(--weight-medium);
    text-transform: uppercase;
    line-height: 1;
  }

  .avatar[data-size='xs'] { width: 20px; height: 20px; font-size: 9px; }
  .avatar[data-size='sm'] { width: 24px; height: 24px; font-size: 11px; }
  .avatar[data-size='md'] { width: 32px; height: 32px; font-size: 14px; }
  .avatar[data-size='lg'] { width: 40px; height: 40px; font-size: 16px; }
  .avatar[data-size='xl'] { width: 64px; height: 64px; font-size: 22px; }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .initial,
  .fallback {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .status {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 25%;
    height: 25%;
    min-width: 8px;
    min-height: 8px;
    border-radius: 50%;
    background: var(--color-offline);
    box-shadow: 0 0 0 2px var(--color-bg);
  }

  .avatar[data-online] .status {
    background: var(--color-online);
  }
</style>